import { render, staticRenderFns } from "./LocationTypeView.vue?vue&type=template&id=7a646a9b&"
import script from "./LocationTypeView.vue?vue&type=script&lang=js&"
export * from "./LocationTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports